exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#nexus {\n    background: #030A03;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n.ui.message {\n        margin: 8px;\n}\n.container {\n        display: flex;\n        width: 100%;\n        height: 100%;\n        position: relative;\ncanvas {\n            display: flex;\n            width: 100%;\n            height: 100%;\n}\n}\n.loading {\n        color: #fefefe;\n        font-size: 120%;\n        margin: 8px;\n        text-align: center;\n.circle.notch {\n            height: 20px;\n            width: 22px;\n}\n}\n}\n", ""]);

// exports
